import axios from 'axios';

import { FetchStatus } from '@powdr/constants';
import { getNodeApiDomain } from '@powdr/utils';

import { WEATHER_PENDING, WEATHER_SUCCESS, WEATHER_ERROR } from '../types';

export const getWeather = () => async (dispatch, getState) => {
  const weatherStatus = getState().weather.status;

  // If more than one component calls the same feed make sure we only make one request
  if (weatherStatus !== FetchStatus.LOADING && weatherStatus !== FetchStatus.PENDING) {
    try {
      dispatch({
        type: WEATHER_PENDING,
        payload: [],
      });
      const res = await axios.get(`${getNodeApiDomain()}/dor/weather-forecast`);
      dispatch({
        type: WEATHER_SUCCESS,
        payload: res.data,
      });
    } catch (error) {
      dispatch({
        type: WEATHER_ERROR,
        payload: error,
      });
    }
  }
};
